import * as React from 'react';
import { Formik, Form } from 'formik';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
/** Custom Imports */
import t from '../../application/translate';
import SvgIcon from '../SvgIcon/SvgIcon';
import withClient from '../../application/client/withClient';
import rightIcon from '../SvgIcon/rightIcon';
import errorProps from './errorProps';
import contactFormSchema from './contactFormSchema';

const initialFormValues = {
  emailSender: '',
  emailMessage: '',
};

class ContactForm extends React.Component {
  state = {
    formSent: false,
    error: false,
  };

  handleSubmit = (values, { resetForm, setSubmitting }) => {
    const { 
      clientPromise, 
      application,
    } = this.props;
    const { language } = application;

    clientPromise.then( client => {
      //ServiceType
      client.service('form-messages')
        .create({
          language,
          ...values
        })
        .then(result =>  {
          this.setState({
            formSent: true,
            error: false,
          }); 
          resetForm();
        })
        .catch(error => {
          this.setState({
            formSent: false,
            error: true,
          });
          setSubmitting(false);
        });
    });
  };

  render() {
    const {
      formSent,
      error,
    } = this.state;

    return (
      <Wrapper>
        <Formik
          initialValues={initialFormValues}
          validationSchema={contactFormSchema()}
          onSubmit={this.handleSubmit}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldTouched,
            values,
            resetForm,
            errors,
            touched,
            isSubmitting,
            ...rest,
          }) => (
            <Form>
              { formSent ? (<ResultGood>{t('contactForm/result/sent')}</ResultGood>) : null }
              { error ? (<ResultBad>{t('contactForm/result/error')}</ResultBad>) : null }
              <div>
                <StyledTextField
                  id='emailSender'
                  name='emailSender'
                  label={t('contactForm/emailSender/label')}
                  value={values.emailSender}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  {...errorProps('emailSender', touched, errors)}
                />
              </div>
              <div>
                <StyledTextField
                  id='emailMessage'
                  name='emailMessage'
                  label={t('contactForm/emailMessage/label')}
                  multiline
                  value={values.emailMessage}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  {...errorProps('emailMessage', touched, errors)}
                />
              </div>
              <StyledGreenButton 
                variant="raised" 
                color="primary" 
                type='submit' 
                disabled={isSubmitting}
              >
                {t('contactForm/button')} <SvgIcon svgIcon={rightIcon} />
              </StyledGreenButton>
            </Form>
          )}
        </Formik>
      </Wrapper>
    );
  }
}

const ContactFormComposed = withClient()(ContactForm);
export default ContactFormComposed;

const Wrapper = styled.div.attrs({
  className: 'mx-auto text-center',
})`
width: 100%;
padding: 0 20px;
  @media screen and (min-width: 425px){
    width: 420px;
  }
  @media screen and (min-width: 768px){
    width: 560px;
    padding: 0 40px;
  }
`;

const ResultGood = styled.div.attrs({
  className: 'text-center text-3xl font-semibold px-4 pb-3 text-green',
})``;

const ResultBad = styled.div.attrs({
  className: 'text-center text-3xl font-semibold px-4 pb-3 text-red',
})``;

const StyledTextField = styled(TextField)`
&& {
  margin-top: 1rem;
  width: 100%;
  div {
    font-size: 1.125rem;
    border-bottom-color: #434875;
    font-family: 'Quicksand', sans-serif;
    font-weight: 600;
    color: #434875;
    text-align: left;
  }
  @media screen and (max-width: 768px){
    ${'' /* margin: 0 40px; */}
  }
  p {
    font-family: 'Quicksand', sans-serif;
  }
  && ::before {
    border-bottom: 1px solid #e5e3d8 !important;
  }
  && ::after {
    border-bottom: 1px solid #f25353;
  }
}

&& div:first-child:hover{
  border-bottom: 0 !important;
}

&& div:hover {
  border-bottom: 1px solid #434875 !important;
}

&& input {
  cursor: pointer;
}

&& textarea {
  cursor: pointer;
}

&& label {
  color: #989689;
  font-size: 1rem;
  font-family: 'Quicksand', sans-serif;
  text-transform: none;
  text-align: center;
  &.shrinked {
    font-size: 0.75rem;
  }
}
`;

const StyledGreenButton = styled(({ ...rest }) => (
  <Button {...rest} classes={{ label: 'label' }} />
))`
  .label {
    font-size: 1.5rem;
    font-family: 'Quicksand', sans-serif;
    font-weight: 600;
    color: #ffffff;
    text-transform: none;
    display: inline-block;
    line-height: 20px;
    padding: 0 0.375rem;
  }

  span {
    float: right;
  }

  && {
    min-height: 3.75rem;
    min-width: 100%;
    background-color: #00b426;
    border-radius: 0.375rem;
    box-shadow: none;
    margin: 3.75rem 0 4.25rem 0;
    align-self: center;
    display: inline;
    @media screen and (min-width: 425px){
      min-width: 16.25rem;
    }
  }

  &&&:hover {
    background-color: #00b426;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js